import { ActivatedRoute, NavigationEnd, ParamMap, Router, ActivatedRouteSnapshot } from '@angular/router';
import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, ReplaySubject, tap, switchMap, map, take, combineLatest, filter } from 'rxjs';
import { Navigation, NavigableWidgetConfigItem } from 'app/core/navigation/navigation.types';
import { UserService } from '@feature/core/user/user.service';
import { NavProviderService } from '@feature/core/navigation/nav-provider.service';
import { NavProviderFactoryService } from '@feature/core/navigation/nav-provider-factory.service';
import { FuseNavigationItem, FuseNavigationService } from '@fuse/components/navigation';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private _navigation: ReplaySubject<Navigation> = new ReplaySubject<Navigation>(1);

  /**
   * Constructor
   */
  constructor(private readonly userService: UserService,
    private readonly navProviderFactoryService: NavProviderFactoryService, private readonly fuseNavigationService: FuseNavigationService) {
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  /**
   * Getter for navigation
   */
  get navigation$(): Observable<Navigation> {
    return this._navigation.asObservable();
  }

  currentPageNavigationItemByWidgetConfigId(configId: string): Observable<FuseNavigationItem> {
    return this.navigation$.pipe(map((navigation) => {
      return this.fuseNavigationService.getItem(configId, navigation.horizontal);
    }));
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Get all navigation data
   */
  get(): Observable<Navigation> {
    return this.userService.user$.pipe(map((user) => this.navProviderFactoryService.get(user.product)),
      switchMap((navService) => navService.get()),
      tap((navigation) => this._navigation.next(navigation)),
      take(1)
    );
  }

}
